import React, { useState, useEffect } from 'react';
import { Empty, Pagination, Checkbox, Select } from 'antd';
import {
  CaretUpOutlined
} from '@ant-design/icons';
import { Loadding } from '../';

import './style';

export default React.forwardRef((props, ref) => {
  const {
    header, onSelectAll, onSetSelected, rows, isPaginition, hasCheckbox, isLoadding, setSelectedCallback
  } = props;

  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(isPaginition === false ? 99999 : 10);
  const isSelectedAll = rows.length > 0 && rows.filter(x => x.selected === true).length === rows.length;

  useEffect(() => {
    const maxPage = Math.ceil(rows.length / pageSize) < 1 ? 1 : Math.ceil(rows.length / pageSize);
    if (page > maxPage) {
      setPage(maxPage);
    }
  }, [rows]);  

  /* const onChangeSelect = (checked, index) => {
    const temp = [].concat(selected);
    temp[index] = checked;
    setSelected(temp);

    if (!setSelectedCallback) return;
    const arr = [];
    for (let i = 0; i < temp.length; i++) {
      if (temp[i] === true) {
        arr.push(true);
      } else {
        arr.push(false);
      }
    }
    setSelectedCallback(arr);
  } */

  const onChangePage = (page, pageSize) => {
    setPage(page);
  }
  const onChangePageSize = (pageSize) => {
    setPageSize(pageSize);
    const maxPage = Math.ceil(rows.length / pageSize);
    if (page > maxPage) {
      setPage(maxPage);
    }
  }

  // const onSelectAll = (checked) => {
  //   const arr = [];
  //   for (let i = 0; i < rows.length; i++) {
  //     arr.push(checked);
  //   }
  //   setSelected(arr);
  // }

  const renderRow = (row, index) => {
    const arr = [];
    arr.push(
      <tr>
        <td className="td">
          {hasCheckbox && <Checkbox
            checked={row.selected}
            onChange={(e) => onSetSelected(e.target.checked, index)}>{index + 1}
          </Checkbox>}
          {!hasCheckbox && <span>{index + 1}</span>}
        </td>
        {
          header.map(col => {
            let content = row[col.item];
            if (col.render) {
              content = col.render(content, row, index);
            }
            return <td className="td" align={col.align}>{content}</td>
          })
        }
      </tr>
    );
    return arr;
  }

  let showCount = 0;
  return (
    <div className="table-container">
      <table className={`simple-table simple-table-bordered`}>
        <thead>
          <tr>
            <th className="th" style={{ width: '32px' }} width="32px">
              {hasCheckbox && <Checkbox checked={isSelectedAll} onClick={(e) => onSelectAll(e.target.checked)}>#</Checkbox>}
              {!hasCheckbox && <span>#</span>}
            </th>
            {
              (header || []).map(item => {
                return (<th className="th" style={{ width: item.width }} width={item.width}>{item.label}
                  {item.sortable && <CaretUpOutlined />}
                </th>)
              })
            }
          </tr>
        </thead>
        {
          (rows || []).length > 0 && (
            <tbody className="table-hover" style={{ position: 'relative' }}>
              {
                (rows || []).map((item, index) => {
                  if (index < pageSize * (page - 1)) return undefined;
                  if (index >= pageSize * (page)) return undefined;
                  showCount += 1;
                  return renderRow(item, index);
                })
              }
            </tbody>
          )
        }
        {
          ((rows || []).length > 0 && isPaginition === true) && (
            <tfoot>
              <tr>
                <td colspan="99" className="td">
                  <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                    <div>显示第<strong> {(page - 1) * pageSize + 1} </strong>到<strong> {(page - 1) * pageSize + showCount} </strong>条记录，总共<strong> {rows.length} </strong>条记录，每页显示<strong>
                      <Select onSelect={onChangePageSize} value={pageSize}>
                        <Select.Option value={10}>10</Select.Option>
                        <Select.Option value={20}>20</Select.Option>
                        <Select.Option value={50}>50</Select.Option>
                        <Select.Option value={100}>100</Select.Option>
                      </Select> </strong>条记录</div>
                    <Pagination onChange={onChangePage} style={{ marginLeft: 'auto' }} pageSize={pageSize} current={page} showSizeChanger={false} total={rows.length} />
                  </div>
                </td>
              </tr>
            </tfoot>
          )
        }
        {
          !isLoadding && (rows || []).length === 0 && (
            <td colspan={99} style={{ padding: '10rem' }}>
              <Empty />
            </td>
          )
        }
        {
          isLoadding && (rows || []).length === 0 && (
            <td colspan={99} style={{ padding: '10rem' }}>
              <Loadding />
            </td>
          )
        }
      </table>
    </div>
  );
});
